// extracted by mini-css-extract-plugin
export default {"-large":"Xh4Wss3Pa7tvx_PyTmDj","container":"piFkKFOG043ZJKbmiHSc"};